import { render } from "./Contratos.vue?vue&type=template&id=2f038994&scoped=true"
import script from "./Contratos.vue?vue&type=script&lang=js"
export * from "./Contratos.vue?vue&type=script&lang=js"

import "./Contratos.vue?vue&type=style&index=0&id=2f038994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f038994"]])

export default __exports__